import React from 'react';
import ReactDOM from 'react-dom/client';
import RoutesComponent from './routes/routes';
import {DataTravelProvider} from './context/dataTravelContext';
import '@fontsource-variable/manrope';
import '@fontsource-variable/montserrat';
import '@fontsource/lato';
import '@fontsource-variable/inter';
import '@fontsource-variable/open-sans';
import '@fontsource-variable/roboto';
import './styles/main.scss'
import ReactGA from "react-ga4";
import { hotjar } from 'react-hotjar';

if(process.env.NODE_ENV === "production" ){
    hotjar.initialize({
        id: process.env.REACT_APP_HOTJAR,
        sv: 6,
    });
    ReactGA.initialize([
        {
            trackingId: process.env.REACT_APP_GA,
        }
    ]);
}






const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <DataTravelProvider>
            <RoutesComponent/>
        </DataTravelProvider>
    </React.StrictMode>
);
